import script from "./DnyApp.vue?vue&type=script&setup=true&lang=js"
export * from "./DnyApp.vue?vue&type=script&setup=true&lang=js"

import "./DnyApp.vue?vue&type=style&index=0&id=09dd6efc&lang=css"

const __exports__ = script;

export default __exports__